export default __webpack_public_path__ + "images/6bf6b87cc1d17ffaf17d26fb7fc3a90d-photography.jpg";